import TimelineMarker from '@trilogy-ds/react/lib/components/timeline/marker/TimelineMarker';
/**
 * Timeline Marker Component
 * @param iconName {IconName} Icon Name - sample : IconName.CHECK
 * @param iconColor {IconColor} Icon Color
 * @param testId {string} Test Id for Test Integration
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additional CSS Classes
 * @param iconClassname {string} Additional CSS Classes for icon
 */
export default TimelineMarker;
//# sourceMappingURL=TimelineMarker.js.map